import React, { useEffect, useRef, useCallback, useState } from 'react';
import { View, useViewport } from '@fairygodboss/ui';
import moment from 'moment-timezone';
import FlowStep from '../../FlowStep';
import { CONFIRM_SUCCESS_STEP_NAME } from '../constants';
import SuccessIllustration from './SuccessIllustration';
import { EmitMetric } from '../../../../Analytics/VisibilityPixel/VisibilityPixel';

import { useFlowControls } from '../../FlowShell/controls';

import './ConfirmSuccessV2.scss';

export const ConfirmSuccessV2 = ({ event }) => {
    const { startTime } = event;
    const { step } = useFlowControls();
    const momentStartTime = moment(new Date(moment.tz(startTime, 'UTC'))).tz(
        'America/New_York'
    );

    const [itsContextAvailable, setItsContextAvalilable] = useState(false);
    const { isXS } = useViewport();
    useEffect(() => {
        if (typeof window?.addthis?.layers?.refresh === 'function') {
            window.addthis.layers.refresh();
        }
    }, [step]);

    const emitShareMetricRef = useRef(true);
    const handleOnClickMetricEmit = useCallback(
        (shareEvent) => {
            if (emitShareMetricRef.current && !itsContextAvailable) {
                emitShareMetricRef.current = false;
                EmitMetric({
                    misc_event_type: 'social-bar-share',
                    share_destination: shareEvent?.data?.service,
                    share: 1,
                });
                setTimeout(() => {
                    emitShareMetricRef.current = true;
                }, 200);
            }
        },
        [itsContextAvailable]
    );

    useEffect(() => {
        if (!window.addthis) {
            setItsContextAvalilable(false);
            const urlToShare = `https://fairygodboss.com${event.viewUrl}`;
            window.addthis_share = {
                url: urlToShare,
                url_transforms: {
                    add: {
                        utm_source: '{{code}}',
                        utm_medium: 'content-share',
                    },
                },
            };
            const script = window.document.createElement('script');
            script.src = `//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5f110312a74b77dd`;
            script.id = 'addthis-script';
            script.async = true;
            document.head.appendChild(script);

            script.onload = () => {
                window.addthis.init();
                window.addthis.addEventListener(
                    'addthis.menu.share',
                    handleOnClickMetricEmit
                );
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 500);
            };
        } else {
            setItsContextAvalilable(true);
        }
    }, [event.viewUrl, handleOnClickMetricEmit]);

    const getTime = () => {
        const timeFormatted = momentStartTime.format('h:mmA');
        return timeFormatted;
    };

    const getDate = () => {
        const month = momentStartTime.format('MMMM D');
        return month;
    };

    return (
        <FlowStep name={CONFIRM_SUCCESS_STEP_NAME}>
            <View
                fontFamily="Open Sans"
                css={{
                    width: !isXS ? '309px' : 'auto',
                    height: !isXS ? '500px' : 'auto',
                    paddingTop: !isXS ? '50px' : 'auto',
                }}
            >
                <View
                    css={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignContent: 'center',
                        fontWeight: '600',
                        marginTop: '40px',
                    }}
                >
                    <SuccessIllustration />
                </View>
                <View
                    css={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignContent: 'center',
                        fontWeight: '600',
                        fontSize: '20px',
                        marginTop: '12px',
                        color: '#353535',
                    }}
                >
                    {event.eventType === 'Virtual Recruiting Event'
                        ? 'Thanks for Registering!'
                        : 'Success, you’re registered!'}
                </View>
                <View
                    css={{
                        textAlign: 'center',
                        fontSize: '16px',
                        marginTop: '8px',
                        color: '#353535',
                    }}
                >
                    {event.eventType === 'Virtual Recruiting Event' ? (
                        <p>
                            A member of our team is currently reviewing your
                            registration. We look forward to seeing you on{' '}
                            <b style={{ fontWeight: '600' }}>{getDate()}</b> at{' '}
                            <b style={{ fontWeight: '600' }}>{getTime()}</b>.
                            Know someone else interested?{' '}
                            <b style={{ fontWeight: '600' }}>
                                Spread the word.
                            </b>
                        </p>
                    ) : (
                        <p>
                            We look forward to seeing you on{' '}
                            <b style={{ fontWeight: '600' }}>{getDate()}</b> at{' '}
                            <b style={{ fontWeight: '600' }}>{getTime()}</b>.
                            Know someone else interested?{' '}
                            <b style={{ fontWeight: '600' }}>
                                Spread the word.
                            </b>
                        </p>
                    )}
                </View>
                <View
                    css={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignContent: 'center',
                        marginTop: '8px',
                        marginBottom: '40px',
                    }}
                >
                    <View
                        width="147px"
                        css={{
                            '.at-svc-link': {
                                marginRight: '0px !important',
                                outline: 'none !important',
                            },
                            '.at-svc-linkedin': {
                                marginLeft: '0px !important',
                                outline: 'none !important',
                            },
                            '.at-svc-facebook': {
                                marginLeft: '0px !important',
                                outline: 'none !important',
                            },
                            '.at-icon-wrapper:focus': {
                                outline: 'none !important',
                            },
                            '.at-icon-wrapper:hover': {
                                opacity: '1 !important',
                            },
                        }}
                    >
                        <View className="addthis_inline_share_toolbox_bg7s" />
                    </View>
                </View>
            </View>
        </FlowStep>
    );
};
